import { useTheme } from 'next-themes'
import { Toaster as SonnerToaster } from 'sonner'

/** Mount once near the app root. Theme follows next-themes. */
export function Toaster() {
  const { resolvedTheme } = useTheme()
  return (
    <SonnerToaster
      theme={(resolvedTheme as 'light' | 'dark' | undefined) ?? 'light'}
      position="top-right"
      // Toasts stack from the top, and the native shells run under the status
      // bar (viewport-fit=cover), so sonner's flat 32px/16px defaults put the
      // first toast beneath the notch — which is where every scan failure is
      // reported. `max()` keeps the desktop offset unchanged where the inset
      // is 0.
      offset={{ top: 'max(32px, calc(env(safe-area-inset-top) + 8px))' }}
      mobileOffset={{ top: 'max(16px, calc(env(safe-area-inset-top) + 8px))' }}
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast:
            'rounded-md border border-border-default bg-surface-elevated shadow-dropdown',
          title: 'text-sm font-semibold text-text-primary',
          description: 'text-xs text-text-secondary',
        },
      }}
    />
  )
}

export { toast } from 'sonner'
